<template>
  <GoogleDocsHTMLExportRenderer :copy="copy" />
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import GoogleDocsHTMLExportRenderer from '@/modules/InformationPages/Legal/components/GoogleDocsHTMLExportRenderer.vue'
import copy from './Privacy.copy.ts'
import useGlobalSettings from '@/hooks/useGlobalSettings';


export default defineComponent({
  name: 'PreviousPrivacy',
  components: { GoogleDocsHTMLExportRenderer },
  setup() {
      const { setHeader } = useGlobalSettings();

      setHeader({
          header: 'Privacy Policy',
          subheader: null,
          heroImage: null,
          metaTitle: `Privacy Policy`,
          registration: false,
          noHero: false,
      });

      return {
          copy
      }
  }
});
</script>

<style scoped>
/* Google doesn't reliably print the same classes for each. Nor does it print <b>'s and other semantic tag names. Thus, this is the CSS (trimmed down) that was generated by Google. 
  I removed declarations for font-family, color, etc. Also added the deep selector. 
  */
>>>ol {
  margin: 0;
  padding: 0
}

>>>table td,
>>>table th {
  padding: 0
}

>>>.c12 {
  border-right-style: solid;
  padding-top: 0pt;
  border-top-width: 0pt;
  border-right-width: 0pt;
  padding-left: 0pt;
  padding-bottom: 0pt;
  border-left-width: 0pt;
  border-top-style: solid;
  margin-left: 36pt;
  border-left-style: solid;
  border-bottom-width: 0pt;
  border-bottom-style: solid;
  orphans: 2;
  widows: 2;
  text-align: left;
  padding-right: 0pt
}

>>>.c26 {
  border-right-style: solid;
  padding: 5pt 5pt 5pt 5pt;
  border-top-width: 1pt;
  border-right-width: 1pt;
  vertical-align: top;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 306.2pt;
  border-bottom-style: solid
}

>>>.c21 {
  border-right-style: solid;
  padding: 5pt 5pt 5pt 5pt;
  border-top-width: 1pt;
  border-right-width: 1pt;
  vertical-align: top;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 161.8pt;
  border-bottom-style: solid
}

>>>.c2 {
  margin-left: 36pt;
  padding-top: 0pt;
  padding-left: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify
}

>>>.c24 {
  margin-left: 36pt;
  padding-top: 14pt;
  padding-left: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify
}

>>>.c1 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify;
}

>>>.c30 {
  padding-top: 0pt;
  padding-left: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify
}

>>>.c3 {
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal
}

>>>.c6 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: left;
}

>>>.c22 {
  margin-left: 36pt;
  padding-top: 0pt;
  padding-left: 0pt;
  padding-bottom: 0pt;
  text-align: justify;
  margin-right: 2.5pt
}

>>>.c35 {
  padding-top: 16pt;
  padding-bottom: 4pt;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

>>>.c0 {
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal
}

>>>.c4 {
  padding-top: 16pt;
  padding-bottom: 4pt;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: justify
}

>>>.c17 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify;
}

>>>.c11 {
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal
}

>>>.c7 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify
}

>>>.c20 {
  padding-top: 15pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: left
}

>>>.c33 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: justify
}

>>>.c16 {
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal
}

>>>.c15 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  orphans: 2;
  widows: 2;
  text-align: left
}

>>>.c32 {
  padding-top: 0pt;
  padding-bottom: 1pt;
  text-align: justify;
  margin-right: 2.5pt
}

>>>.c25 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  text-align: justify;
  margin-right: 2.5pt
}

>>>.c42 {
  padding-top: 10pt;
  padding-bottom: 1pt;
  text-align: justify;
  margin-right: 2.5pt
}

>>>.c8 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  text-decoration: underline
}

>>>.c28 {
  border-spacing: 0;
  border-collapse: collapse;
  margin-right: auto
}

>>>.c14 {
  padding: 0;
  margin: 0
}

>>>.c5 {
  text-decoration: inherit
}

>>>.c23 {
  margin-left: 72pt;
  padding-left: 0pt
}

>>>.c34 {
  max-width: 468pt;
  padding: 72pt 72pt 72pt 72pt
}

>>>.c36 {}

>>>.c31 {}

>>>.c39 {}

>>>.c10 {
  font-style: italic
}

>>>.c18 {}

>>>.c41 {}

>>>.c40 {
  margin-left: 72pt
}

>>>.c38 {}

>>>.c27 {}

>>>.c37 {}

>>>.c9 {
  font-weight: 700
}

>>>.c19 {}

>>>.c29 {
  margin-left: 36pt
}

>>>.c43 {}

>>>.title {
  padding-top: 0pt;
  padding-bottom: 3pt;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

>>>.subtitle {
  padding-top: 0pt;
  padding-bottom: 16pt;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

>>>li {}

>>>p {
  margin: 0;
}
</style>
